import type { TabIconId } from '../../../core/navigation/tabIconConfig';

/** 24×24 paths aligned with SF Symbol semantics in tabIconConfig. Shared by web SVG and native Skia. */
export const TAB_ICON_PATHS: Record<TabIconId, { outline: string; filled: string }> = {
  home: {
    outline: 'M4 10.5L12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5z',
    filled: 'M12 3.2L3 10v11h6v-6h6v6h6V10L12 3.2z',
  },
  spend: {
    outline: 'M4 7h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm2 3h4M14 10h4',
    filled:
      'M3 7.5A1.5 1.5 0 0 1 4.5 6h15A1.5 1.5 0 0 1 21 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 16.5v-9zM6 10.5h3.5v1H6v-1zm7.5 0H17v1h-3.5v-1z',
  },
  wealth: {
    outline: 'M4 18h16M6 16l4-5 4 3 5-7',
    filled:
      'M4 18.5h16M6.5 15.8l3.5-4.4 3.8 2.9 4.7-6.1 1.5 1.2-6.2 8.1-3.8-2.9-3.2 4.1-1.5-1.9z',
  },
  loan: {
    outline: 'M4 20h16M6 20V10l6-5 6 5v10M9 20v-5h6v5M10 13h.01M14 13h.01',
    filled:
      'M12 3.5L4.5 9.5V20h5.5v-5.5h4V20H19.5V9.5L12 3.5zM10.5 12.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z',
  },
  grow: {
    outline: 'M4 20h16M7 20V12h3v8M14 20V8h3v12M4 16h16',
    filled:
      'M4 19.5h16v1.5H4v-1.5zM7 11.5h3.5V19H7v-7.5zm7-4h3.5V19H14V7.5zM4 15.5h16V17H4v-1.5z',
  },
};
